import type { FC } from 'react';

import { useParams, useMatch, Navigate } from '@tanstack/react-router';

import { useIntlStore } from '@dcentralexpedientedigital/fe-shared/stores/intl-store';

export const CatchAllRedirect: FC = () => {
    const params = useParams({
        strict: false,
    }) as Record<string, string>;
    const match = useMatch({ strict: false });
    const urlParams = new URLSearchParams(window.location.search);
    const [locale] = useIntlStore((state) => [state.locale]);
    const path = match.pathname;

    if (!params.lang && locale) {
        return (
            <Navigate
                to={`/${locale}/${path}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`}
            />
        );
    }
    return <Navigate to={`/${locale}/404`} />;
};
